// extracted by mini-css-extract-plugin
export default {"container":"Info_container__3larQ"};